/* src/app/FW/controls/toggle-entry/toggle-entry.component.scss */
:host ::ng-deep .mat-mdc-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar {
  background-color: #3f86e8;
}
/*# sourceMappingURL=toggle-entry.component.css.map */
